



































import Vue from "vue";
import { get } from "lodash-es";
import { slideStream } from "@/streams";
import { mutateState } from "@/store";
import { formatNumber } from "@/utils/index"
export default Vue.extend({
  props: ["config"],
  filters: {
    formatNumber
  },
  methods: {
    // logger: console.info,
    handleClick(slide: number) {
      mutateState(s => {
        s.slide = slide;
      });
    }
  },
  data() {
    return {
      slide: 0,
      tabs: get(this.config, "groups", [])
    };
  },
  mounted() {
    slideStream.subscribe(v => {
      this.slide = v;
    });
  }
});
